/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class MonkeysGoldGameAssets {

    public static INTRO_BACKGROUND:string = "introBackground";
    public static INTRO_LOGO = "resources/images/intro/logo-landscape-16.9.png";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FS_BACKGROUND:string = "fsBackground";

    public static INTRO_BORDER_TILE = "resources/images/intro/Intro_Divider.png";
    public static INTRO_BLURRED_BACKGROUND = "resources/images/intro/introBackgroundBlurred.jpg";
    public static INTRO_FEATURE_1 = "resources/images/intro/Intro_Feature_1.png";
    public static INTRO_FEATURE_2 = "resources/images/intro/Intro_Feature_2.png";
    public static INTRO_FEATURE_3 = "resources/images/intro/Intro_Feature_3.png";
    public static INTRO_FEATURE_4 = "resources/images/intro/Intro_Feature_4.png";

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(MonkeysGoldGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("numbersWinCountUpGray", "fonts/bitmapfonts/NumbersWinCountUpGray.fnt"),
                    new BitmapFontAsset("numbersWinCountUpCondensed", "fonts/bitmapfonts/NumbersWinCountUpCondensed.fnt"),
                    new BitmapFontAsset("xpaysCountup", "fonts/bitmapfonts/XpaysCountup.fnt")
                ]
            },
            {
                name : "intro",
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json"),
                    new TextureAsset("intro1", "sheets/intro/intro1.json"),
                    new TextureAsset("intro2", "sheets/intro/intro2.json"),
                    new TextureAsset("intro3", "sheets/intro/intro3.json"),
                    new TextureAsset("intro4", "sheets/intro/intro4.json")
                ],
                animations : {
                    "mainGameLogo" : "logo-landscape-16.9",
                    "bonusGameLogo" : "FS_logo-landscape-16.9"
                }
            }
        ],
        main : [
            {
                name : "freespinJpeg",
                assets : [
                    new TextureAsset("freespinJpeg0", "sheets/freespinJpeg/freespinJpeg0.json")
                ],
                animations : {
                    "fsBackground" : "FS_background"
                }
            },
            {
                name : "freespin",
                assets : [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json")
                ],
                animations : {}
            },
            {
                name : "mainDice",
                assets : [
                    new TextureAsset("mainDice0", "sheets/mainDice/mainDice0.json")
                ],
                animations : {}
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json")
                ],
                animations : {
                    "reelDivider" : "ui/reelDividers/div",
                    "reelDividerNearWin" : "ui/reelDividers/div-attention",
                    "Shine/Shine" : "SymbolTurnAnimation/Shine/Shine",
                    "moneyPile" : "big wins/gold_coins/gold_coins",
                    "bigWinRain0" : "big wins/Coins animation/coins_",
                    "coinExplosion" : "big wins/blast partical/blast_partical_",
                    "glowdust" : "fortune_wheel/glowdust"
                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json")
                ],
                animations : {
                    "potentialGlow" : "potential_glow"
                }
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("spineSymbolTurn1x1", "spines/turn1x1.json"),
                    new SpineAsset("spineSymbolTurn2x2", "spines/turn2x2.json"),
                    new SpineAsset("spineSymbolTurn3x3", "spines/turn_3x3.json"),
                    new SpineAsset("spineSymsWin", "spines/syms_win.json"),
                    new SpineAsset("spineYellowSmoke", "spines/yellow_smoke.json"),
                    new SpineAsset("spineInitialWin", "spines/initial_win.json"),
                    new SpineAsset("spineBonusLand", "spines/bonus.json"),
                    new SpineAsset("spineVines", "spines/vines_bone.json"),
                    new SpineAsset("spineBigWin", "spines/big_wins.json"),
                    new SpineAsset("spineBigWinMonkey", "spines/monkey dance.json"),
                    new SpineAsset("spineDiceComing", "spines/Fortune_dice/dice_coming.json"),
                    new SpineAsset("spineDiceStart", "spines/Fortune_dice/dice_start.json"),
                    new SpineAsset("spineDiceAnimation", "spines/Fortune_dice/dice_animation.json"),
                    new SpineAsset("spineDiceWin", "spines/Fortune_dice/dice_win.json"),
                    new SpineAsset("spineWaterfall", "spines/water_fall.json"),
                    new SpineAsset("spinePond", "spines/Pond _water.json"),
                    new SpineAsset("spineBonusGameIntro", "spines/fs_intro_new.json"),
                    new SpineAsset("spineBonusSymbolFrame", "spines/bonus_anticipation_animation.json"),
                    new SpineAsset("spineDiceWinShine", "spines/Fortune_dice/dice_back_shine.json"),
                    new SpineAsset("spinePlusOne", "spines/Plus_one.json"),
                    new SpineAsset("spineDiceMoving", "spines/Dice_moving.json"),
                    new SpineAsset("spineWinBlastYellow", "spines/win_blast_yellow.json")
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations : {
                    "L_bg" : "L_bg/L_bg",
                    "X/X_spin" : "X/X",
                    "W_hidden/W_hidden" : "W/W",
                    "W_hidden/W_hidden_spin" : "W/W",
                    "L1_hidden/L1_hidden" : "L1/L1",
                    "L1_hidden/L1_hidden_spin" : "L1/L1",
                    "L2_hidden/L2_hidden" : "L2/L2",
                    "L2_hidden/L2_hidden_spin" : "L2/L2",
                    "L3_hidden/L3_hidden" : "L3/L3",
                    "L3_hidden/L3_hidden_spin" : "L3/L3",
                    "L4_hidden/L4_hidden" : "L4/L4",
                    "L4_hidden/L4_hidden_spin" : "L4/L4",
                    "L5_hidden/L5_hidden" : "L5/L5",
                    "L5_hidden/L5_hidden_spin" : "L5/L5",
                    "M1_hidden/M1_hidden" : "M1/M1",
                    "M1_hidden/M1_hidden_spin" : "M1/M1",
                    "M1_2_hidden/M1_2_hidden" : "M1/M1",
                    "M1_2_hidden/M1_2_hidden_spin" : "M1/M1",
                    "M1_3_hidden/M1_3_hidden" : "M1/M1",
                    "M1_3_hidden/M1_3_hidden_spin" : "M1/M1",
                    "M1_4_hidden/M1_4_hidden" : "M1/M1",
                    "M1_4_hidden/M1_4_hidden_spin" : "M1/M1",
                    "M1_5_hidden/M1_5_hidden" : "M1/M1",
                    "M1_5_hidden/M1_5_hidden_spin" : "M1/M1",
                    "M1_6_hidden/M1_6_hidden" : "M1/M1",
                    "M1_6_hidden/M1_6_hidden_spin" : "M1/M1",
                    "M1_7_hidden/M1_7_hidden" : "M1/M1",
                    "M1_7_hidden/M1_7_hidden_spin" : "M1/M1",
                    "M2_hidden/M2_hidden" : "M2/M2",
                    "M2_hidden/M2_hidden_spin" : "M2/M2",
                    "M3_hidden/M3_hidden" : "M3/M3",
                    "M3_hidden/M3_hidden_spin" : "M3/M3",
                    "M4_hidden/M4_hidden" : "M4/M4",
                    "M4_hidden/M4_hidden_spin" : "M4/M4",
                    "M5_hidden/M5_hidden" : "M5/M5",
                    "M5_hidden/M5_hidden_spin" : "M5/M5",
                    "M1_1_colossalx2/M1_1_colossalx2" : "M1_colossalx2/M1_colossalx2",
                    "M1_2_colossalx2/M1_2_colossalx2" : "M1_colossalx2/M1_colossalx2",
                    "M1_3_colossalx2/M1_3_colossalx2" : "M1_colossalx2/M1_colossalx2",
                    "M1_4_colossalx2/M1_4_colossalx2" : "M1_colossalx2/M1_colossalx2",
                    "M1_5_colossalx2/M1_5_colossalx2" : "M1_colossalx2/M1_colossalx2",
                    "M1_1_colossalx3/M1_1_colossalx3" : "M1_colossalx3/M1_colossalx3",
                    "M1_2_colossalx3/M1_2_colossalx3" : "M1_colossalx3/M1_colossalx3",
                    "M1_3_colossalx3/M1_3_colossalx3" : "M1_colossalx3/M1_colossalx3",
                    "M1_4_colossalx3/M1_4_colossalx3" : "M1_colossalx3/M1_colossalx3",
                    "M1_5_colossalx3/M1_5_colossalx3" : "M1_colossalx3/M1_colossalx3",
                    "M1_1_colossalx2/M1_1_colossalx2_spin" : "M1_colossalx2/M1_colossalx2_spin",
                    "M1_2_colossalx2/M1_2_colossalx2_spin" : "M1_colossalx2/M1_colossalx2_spin",
                    "M1_3_colossalx2/M1_3_colossalx2_spin" : "M1_colossalx2/M1_colossalx2_spin",
                    "M1_4_colossalx2/M1_4_colossalx2_spin" : "M1_colossalx2/M1_colossalx2_spin",
                    "M1_5_colossalx2/M1_5_colossalx2_spin" : "M1_colossalx2/M1_colossalx2_spin",
                    "M1_1_colossalx3/M1_1_colossalx3_spin" : "M1_colossalx3/M1_colossalx3_spin",
                    "M1_2_colossalx3/M1_2_colossalx3_spin" : "M1_colossalx3/M1_colossalx3_spin",
                    "M1_3_colossalx3/M1_3_colossalx3_spin" : "M1_colossalx3/M1_colossalx3_spin",
                    "M1_4_colossalx3/M1_4_colossalx3_spin" : "M1_colossalx3/M1_colossalx3_spin",
                    "M1_5_colossalx3/M1_5_colossalx3_spin" : "M1_colossalx3/M1_colossalx3_spin"
                }
            }
        ]
    };
}
